import React from "react"
import "./brand.css"
import { dance, home_tutor, karate, singing, teacher, yoga } from "./imports"
import { Link } from "react-router-dom";

const servicesList = [
  { to: "/dance",                img: dance,       alt: "Dance",        label: "Dance Class" },
  { to: "/homeTution",           img: home_tutor,  alt: "Home Tuition", label: "Home Tuition" },
  { to: "/martialArt",           img: karate,      alt: "Martial Art",  label: "All Sports Classes" },
  { to: "/music",                img: singing,     alt: "Music",        label: "Singing Class" },
  { to: "/special",              img: teacher,     alt: "Special",      label: "Special Educators and Shadow Teachers" },
  { to: "/yoga",                 img: yoga,        alt: "Yoga",         label: "Yoga Class" },
  { to: "/students-for-teachers",img: home_tutor,  alt: "Find Students",label: "Special Child" },
];

function Services() {
  return (
    <div className="services_main" id="services">
      <h1>Our Services</h1>
      <p className="section__subtitle">Choose from our wide range of learning programs</p>
      <div className="container">
        {servicesList.map(({ to, img, alt, label }) => (
          <div className="services_item" key={to}>
            <Link to={to}>
              <img src={img} alt={alt} />
              <h3>{label}</h3>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Services;